import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

import { SERVICES } from '@shared/constants/apiConfig';
import { Loader } from '@shared/enhancers/withLoader';

import { ILenderInfo } from '../../../../interfaces';

export const RequirementInfo = ({ lenderId }: { lenderId: string }) => {
  const [html, setHTML] = useState<{ __html: string }>({ __html: '' });
  const { data: lenderInfo, isLoading } = useSWR<ILenderInfo>(`${SERVICES.LENDER}/lenders/${lenderId}`);

  useEffect(() => {
    const renderRequirements = async () => {
      const resp = `${lenderInfo?.generalInfo.requirements}`;
      return { __html: resp };
    };
    renderRequirements().then((result) => setHTML(result));
  }, [lenderInfo]);

  return (
    <Box>
      {lenderInfo?.generalInfo.requirements ? (
        <Box dangerouslySetInnerHTML={html} />
      ) : isLoading ? (
        <Loader />
      ) : (
        <Typography fontWeight='bold' justifyContent='center' >No Lender Requirements avaliable</Typography>
      )}
    </Box>
  );
};

